import ViewBase from "../../../../framework/core/mvvm/view_base";

const { ccclass, property } = cc._decorator;

@ccclass
export default class  TableMatchView extends ViewBase{

    @property(cc.Label)
    public contentLabel : cc.Label = null;

    private pointNum : number;

    private originText : string;

    constructor(){
        super();
    }

    onShow(){

        super.onShow();
        this.pointNum = 0;
        if (!this.originText) {
            this.originText = this.contentLabel.string;           
        }        
        this.unschedule(this.updatePoint);
        this.schedule(this.updatePoint,0.5,cc.macro.REPEAT_FOREVER);
    }    

    private updatePoint(){

        if ( ++this.pointNum > 3) {
            
            this.pointNum = 0;
        }

        let str = "";
        for (let index = 0; index < this.pointNum; index++) {
            
            str += ".";
        }
                
        this.contentLabel.string = this.originText + str;
    }
}
